import React from 'react'

import { Tooltip as AntTooltip } from 'antd'
import styled, { useTheme } from 'styled-components'

import { TooltipProps } from 'antd/lib/tooltip'

import { BriqTheme, Color, FontSizes } from '../theme'

export interface IconTooltip extends Pick<TooltipProps, 'placement' | 'trigger'> {
  icon: React.ReactNode
  title: string
  color: Color
  size?: FontSizes
}

const StyledTooltip = styled(AntTooltip)<Omit<IconTooltip, 'icon' | 'color'>>`
  font-size: ${({ theme, size }) => theme.fontSizes[size || 'medium']};
`

export const IconTooltip = ({ icon, title, color, size, ...rest }: IconTooltip) => {
  const theme = useTheme() as BriqTheme
  return (
    <StyledTooltip title={title} color={theme.colors[color]} size={size} {...rest}>
      {icon}
    </StyledTooltip>
  )
}
